// extracted by mini-css-extract-plugin
export default {"testElement":"style_testElement__PsVhA","blue":"style_blue__WfFg+","green":"style_green__1FwHs","yellow":"style_yellow__nuwR6","red":"style_red__EGXHu"};